<script>
/**
 * Component: Packages: Payments
 *
 * @author PH
 */
export default {
  props: ["l18n", "selected", "required", "methods"],

  data: function() {
    return {};
  },

  methods: {
    /**
     * Function manages the state of selected payment method
     *
     * @author PH
     * @return void
     */
    selectMethod(id) {
      let settings = this.$store.getters.getSectionData("packages", "settings");
      if (settings && settings.payments) {
        settings.payments.selected = id;

        this.$store.commit("updateSectionSettings", {
          section: "packages",
          values: {
            payments: settings.payments
          }
        });
      }
    }
  }
};
</script>

<template>
  <div class="signup-packages-payments">
    <div class="signup-packages-payments__title">
      <h3>{{l18n.header}}</h3>
    </div>

    <div class="signup-packages-payments__items">
      <div class="signup-packages-payments__item" v-for="method in methods" v-bind:key="method.id">
        <button
          type="button"
          class="signup-packages-payments__item-wrap"
          :class="{active: selected === method.id}"
          @click="selectMethod(method.id)"
        >{{method.title}}</button>
      </div>
    </div>
  </div>
</template>

